import { defineStore } from '#q-app'
import { createPinia } from 'pinia'

export { useAuthStore } from './AuthStore'
export { useUserStore } from './UserStore'
export { useGlobalStore } from './GlobalStore'
export { useExploreStore } from './ExploreStore'
export { useRoleStore } from './RoleStore'
export { useAtcStore } from './AtcStore'
export { useActiveSubstanceStore } from './ActiveSubstanceStore'
export { useNotificationStore } from './NotificationStore'
export { useFavGroupStore } from './FavGroupStore'
export { useSessionStore } from './SessionStore'
export { usePasskeyStore } from './PasskeyStore'
export { useWatchlistStore } from './WatchlistStore'
export { useMaintenanceStore } from './MaintenanceStore'

export default defineStore(() => createPinia())
